import { ROUTES_NOT_SHOW_CONFIRM } from '@/constants/routerName';
import {
  NUMBER_EN_US_FORMAT,
  DB_DATE_TIME_FORMAT,
  DEFAULT_DATE_TIME_FORMAT,
} from '@/constants/common';
import dayjs from '@/plugins/dayjs';

const AppFunctions = {
  install(app) {
    const App = app.config.globalProperties;
    App.$formatNumber = (num, type = null) => {
      if (!num) return 0;
      if (type === NUMBER_EN_US_FORMAT) {
        return new Intl.NumberFormat('en-US', {
          style: 'decimal',
          maximumFractionDigits: 20,
        }).format(num);
      }
      return parseFloat(num);
    };

    App.$formatTime = (time, type = null) => {
      if (!time) return '';
      if (type) {
        time = dayjs(time).format(type);
      } else {
        time = time.replace(/-/g, '/');
      }
      return time;
    };
    App.$formatDateTime = (dateTime) => {
      if (!dateTime) return '';
      const dateCurrent = App.$formatDateUtcType2(dateTime, DEFAULT_DATE_TIME_FORMAT);
      let dateCurrentDayjs = dayjs(dateCurrent).$d;
      let day = dateCurrentDayjs.getDate();
      let month = dateCurrentDayjs.getMonth() + 1;
      const year = dateCurrentDayjs.getFullYear();
      let hour = dateCurrentDayjs.getHours();
      let minutes = dateCurrentDayjs.getMinutes();
      // eslint-disable-next-line no-unused-expressions
      day < 10 ? (day = `0${day}`) : '';
      // eslint-disable-next-line no-unused-expressions
      month < 10 ? (month = `0${month}`) : '';
      // eslint-disable-next-line no-unused-expressions
      hour < 10 ? (hour = `0${hour}`) : '';
      // eslint-disable-next-line no-unused-expressions
      minutes < 10 ? (minutes = `0${minutes}`) : '';
      dateCurrentDayjs = `${year}年${month}月${day}日 ${hour}時${minutes}分`;
      return dateCurrentDayjs;
    };
    App.$filterByProperty = (arr, property, val) => {
      if (arr) {
        return arr.filter((item) => item[property] === val);
      }
      return [];
    };
    /* eslint-disable */
    App.$checkRouteNotShowConfirmPopup = (from, to) => {
      if (from === to) {
        return true;
      }

      return false;
    };

    App.$subString = (str) => {
      if (!str) {
        return '';
      }
      return str.substring(0, str.length - 1);
    };

    App.$formatDateUtc = (time, type = null) => {
      if (!time) return '';
      if (type) {
        let timeUtc;
        if (typeof time === 'object') {
          timeUtc = dayjs(`${time}Z`).format();
        } else {
          timeUtc = dayjs.utc(time.split(' ').join('T')).format();
        }
        const timeLocal = dayjs(timeUtc).utc(true).format(type);
        return timeLocal;
      }
      return time;
    };

    App.$formatDateUtcType2 = (time, type = null) => {
      if (type) {
        const timeLocal = dayjs(`${time}`).utc(true).format(type);
        return timeLocal;
      }
      return time;
    };

    App.$formatDateUtcDiff = (time, type = null) => {
      const now = dayjs();
      const nowCompare = dayjs(now);
      if (type) {
        const timeLocal = dayjs(`${time}Z`).utc(true).format(type);
        const timeLocalMinute = dayjs(`${time}Z`).utc(true).format(DB_DATE_TIME_FORMAT);
        const timeDiff = nowCompare.diff(timeLocalMinute, 'minute', true);
        return {
          timeDiff,
          timeLocal,
        };
      }
      return { timeLocal: time };
    };

    App.$convertToLocalTime = (time) => {
      if (!time) return '';
      time = time.replace(/-/g, '/');
      time += ' UTC';
      time = new Date(time);
      return time.toString();
    };

    // App.$formatTimeUTCToLocal = (value) => {
    //   let time = null;
    //   if (value) {
    //     time = new Date(`${dayjs(value, DB_DATE_TIME_FORMAT).format(DB_DATE_TIME_FORMAT)} UTC`);
    //   }

    //   return time;
    // };

    App.$convertMoney = (money) => {
      money = parseInt(money, 10);
      let kyo = 0;
      let trillion = 0;
      let billion = 0;
      let million = 0;
      let circle = 0;
      let newMoney = '';

      if (money >= 1e16) {
        kyo = Math.floor(money / 1e16);
        newMoney += kyo > 0 ? kyo + '京' : '';
        money = money % 1e16;
      }

      if (money >= 1e12) {
        trillion = Math.floor(money / 1e12);
        newMoney += trillion > 0 ? trillion + '兆' : '';
        money = money % 1e12;
      }

      if (money >= 1e8) {
        billion = Math.floor(money / 1e8);
        newMoney += billion > 0 ? billion + '億' : '';
        money = money % 1e8;
      }

      if (money >= 1e4) {
        million = Math.floor(money / 1e4);
        newMoney += million > 0 ? million + '万' : '';
        money = money % 1e4;
      }

      circle = money % 1e4;
      newMoney += circle > 0 ? circle + '円' : '円';

      return newMoney;
    };

    Object.keys(App).forEach((properties) => {
      app.provide(properties, App[properties]);
    });
  },
};

export default AppFunctions;
